module.exports = __webpack_public_path__ + "static/media/calendar-purple.77d1980e.svg";